<template>
  <w-jst-picker v-bind="$attrs" :url="terytUrl" v-on="$listeners" />
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { config } from '@/utils/config';

// @vuese
// Obudowanie komponentu w-jst-picker
// @group FormComponents
export default {
  components,
  inheritAttrs: false,
  data() {
    return {
      terytUrl: config.terytUrl
    };
  }
};
</script>
